<template>
  <MainLayout>
    <Head title="Options" />
    <template v-slot:header>
      <span ref="topAnchor">
        Options
      </span>
    </template>

    <div class="mb-4" v-if="$can('options.write')">
      <ButtonGroup>
        <Link :href="$route('options.create')">Add Option</Link>

        <button v-if="changed"
                @click="saveOrder"
                :disabled="saving"
                :class="{ 'opacity-70': saving }"
                class="-primary">
          Save
        </button>
      </ButtonGroup>
    </div>

    <DataTable>
      <template v-slot:header>
        <th scope="col" class="">
          Name
        </th>
        <th scope="col">
          Label
        </th>
        <th scope="col">
          Image
        </th>
        <th scope="col">
          Paired With
        </th>
        <th scope="col">
          <span class="sr-only">Edit</span>
        </th>
      </template>

      <tr v-for="(option, index) in sortedOptions" :key="option.id">
        <td>{{ option.name }}</td>
        <td>{{ option.label }}</td>
        <td>
          <CheckCircleIcon v-if="option.has_image"
                           class="w-4 h-4 text-green-600"/>
        </td>
        <td>{{ option.paired_with }}</td>
        <td>
          <button @click="move(index, -1)" v-show="index">
            <ArrowSmUpIcon class="w-4 h-4 inline-block" />
          </button>
          <button @click="move(index, 1)" v-show="index + 1 != options.length">
            <ArrowSmDownIcon class="w-4 h-4 inline-block" />
          </button>

          <button type="button"
                  class="text-red-600 hover:text-red-900"
                  v-if="$can('options.write')"
                  @click="deleteOption(option)">Delete</button>

          <Link :href="$route('options.attributes', [option.id])"
                class="ml-4 text-indigo-600 hover:text-indigo-900">Attributes</Link>

          <Link :href="$route('options.edit', [option.id])"
                class="ml-4 text-indigo-600 hover:text-indigo-900">Edit</Link>
        </td>
      </tr>
    </DataTable>
  </MainLayout>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import PageComponent from '@/pages/page-component'
import DataTable from '@/components/data-table.vue'
import {
  CheckCircleIcon,
  ArrowSmUpIcon,
  ArrowSmDownIcon,
} from '@heroicons/vue/solid'
import { Inertia } from '@inertiajs/inertia'
import UsesPermissions from '@/mixins/uses-permissions'

export default {
  mixins: [
    PageComponent,
    UsesPermissions,
  ],

  components: {
    DataTable,
    Link,
    CheckCircleIcon,
    ArrowSmUpIcon,
    ArrowSmDownIcon,
  },

  props: {
    options: Object,
    ts: Number,
  },

  data() {
    return {
      changed: false,
      saving: false,
    }
  },

  computed: {
    sortedOptions() {
      return [...this.options]
        .sort((left, right) => left.frontend_sort_order - right.frontend_sort_order)
    }
  },

  methods: {
    move(index, change) {
      const option = this.sortedOptions[index];
      const swapWith = this.sortedOptions[index + change];

      this.changed = true;

      option.frontend_sort_order = index + change;
      swapWith.frontend_sort_order = index;
    },

    saveOrder() {
      this.saving = true;

      const options = this.sortedOptions.map(item => item.id);

      Inertia.post(this.$route('options.sort'), { options });
    },

    deleteOption (option) {
      if (confirm('Are you sure?')) {
        Inertia.delete(this.$route('options.destroy', [option.id]), {
          onFinish: () => {
            this.$refs.topAnchor.scrollIntoView()
          }
        })
      }
    }
  },

  watch: {
    ts(newValue, oldValue) {
      if (newValue != oldValue) {
        this.saving = false;
        this.changed = false;
      }
    }
  }
}
</script>
